<template>
  <div id="alerts-table-container">
    <div class="filter-container">
      <div class="filter-sub-container">
        <div>Filters: </div>
        <CycleSystemFilter />
      </div>
      <div class="type-container">
        <div :class="['alert-type', alertType === 'active' ? 'active' : '']" @click="changeAlertsType('active')">
          Active
        </div>
        <div :class="['alert-type', alertType === 'history' ? 'active' : '']" @click="changeAlertsType('history')">
          History
        </div>
      </div>
    </div>
    <div class="at-container">
      <v-data-table :headers="headers" :items="alertTableData" :loading="loading" height="700px" fixed-header
        hide-default-footer disable-pagination>
        <template #[`item.pushTitle`]="{ item }">
          <td>
            <span>{{ item.pushTitle ? item.pushTitle : item.title }}</span>
          </td>
        </template>
        <template #[`item.did`]="{ item }">
          <td>
            <span>{{ item.uid.substring(15, 20) + "-" + item.did }}</span>
          </td>
        </template>
        <template #[`item.firstOccurred`]="{ item }">
          <td>
            <span>{{ formattedDate(item.firstOccurred) }}</span>
          </td>
        </template>
        <template #[`item.lastOccurred`]="{ item }">
          <td>
            <span>{{ formattedDate(item.lastOccurred) }}</span>
          </td>
        </template>
        <template #[`item.boundaryValue`]="{ item }">
          <td>
            <span>{{ item.boundaryValue }}</span>
            <v-icon v-if="item.alertDetails" class="ml-2" color="#1B2138" dark medium>
              mdi-eye-outline
            </v-icon>
            <div v-if="item.alertDetails" class="tooltip">
              <b>Alert Details</b>
              <ul v-for="(r, idx) in parseAlertsMetaData(item.alertDetails)" :key="idx">
                <li>{{ r }}</li>
              </ul>
            </div>
          </td>
        </template>
        <template #[`item.archivedReason`]="{ item }">
          <td class="stack">
            <span>{{ item.status }}</span>
            <span class="subtitle">{{ item.archivedReason }}</span>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import CycleSystemFilter from '@shared/components/customerDetail/CycleSystemFilter.vue';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

export default {
  name: 'AlertsTable',
  components: { CycleSystemFilter },
  mixins: [unitPreferencesMixin],
  props: {
    alertTableData: Array,
    loading: Boolean,
    zones: Array,
    changeFilter: Function,
    categories: Array,
    alertType: String,
    changeAlertsType: Function,
  },
  data() {
    return {
      headers: [{
        text: 'System Name',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'systemName',
      }, {
        text: 'Serial',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'did',
      }, {
        text: 'Location',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'location',
      }, {
        text: 'Severity',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'severity',
      }, {
        text: 'Category',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'category',
      }, {
        text: 'Alert',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'pushTitle',
      },
      {
        text: 'Details',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'boundaryValue',
      }, {
        text: 'First Occurred',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'firstOccurred',
      }, {
        text: 'Last Occurred',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'lastOccurred',
      }, {
        text: 'Status',
        align: 'start',
        filterable: false,
        sortable: true,
        value: 'archivedReason',
      }],
    };
  },
  mounted() {
    this.$store.dispatch('getCustomerAlert');
  },
  methods: {
    parseAlertsMetaData(meta) {
      let replaced = meta.replace("{","");
      let splitChar = '\n';
      if (!replaced) {
        return replaced;
      }
      if (replaced.includes(';')) {
        splitChar = ';';
      }
      if (replaced.includes(',')) {
        splitChar = ',';
      }
      const parsedMeta = replaced.split(splitChar);
      parsedMeta.pop();
      return parsedMeta;
    },
  },
};
</script>

<style lang="scss">
#alerts-table-container {
  width: 100%;
  max-width: 1705px;

  .filter-container {
    display: grid;
    grid-auto-flow: column;
    justify-content: space-between;
    align-items: flex-start;

    .filter-sub-container {
      display: grid;
      grid-auto-flow: column;
      gap: 10px;
      align-items: center;
    }

    .type-container {
      display: grid;
      grid-auto-flow: column;
      justify-content: left;
      padding: 0 0 20px 0;
      font-size: 1.2rem;
      font-weight: 500;

      .alert-type {
        background-color: $N60;
        padding: 2px 10px;
        color: $WHITE;
        cursor: pointer;

        &.active {
          color: $SUNSET100;
          background-color: $N90;
        }
      }
    }
  }

  .at-container {
    background-color: $WHITE;
    box-shadow: 0 0 7px 2px rgba(9, 15, 32, 0.02);
    border-radius: 6px;
    padding-bottom: 12px;

    .v-data-table__wrapper {
      height: 700px;

      thead {
        tr {
          th {
            background-color: $N100;
            text-transform: uppercase;
            color: $WHITE;
            font-size: 15px;
            font-weight: 500;

            .mdi-checkbox-blank-outline::before,
            .mdi-checkbox-marked::before,
            .mdi-minus-box::before,
            .mdi-arrow-up::before {
              color: $WHITE;
            }
          }
        }
      }

      tbody {
        tr {
          td {
            position: relative;
            border-bottom: 0;

            &:hover {
              .tooltip {
                display: flex;
                flex-direction: column;
              }
            }

          }

          .stack {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .subtitle {
              font-size: 0.675rem;
            }
          }

          &:hover {
            background: none;
          }

          &:nth-child(even) {
            background-color: $NBLUE5;
          }
        }
      }
    }

    .tooltip {
      position: absolute;
      width: 350px;
      background-color: $PRIMARY_LIGHT;
      color: $N95;
      align-items: flex-start;
      justify-content: center;
      border-radius: 4px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      padding: 10px 10px;
      z-index: 1;
      top: 28px;
      left: -40px;
      display: none;
    }
  }
}
</style>
